import { render, staticRenderFns } from "./mail_conditions.vue?vue&type=template&id=5b63289e&scoped=true&"
import script from "./mail_conditions.vue?vue&type=script&lang=js&"
export * from "./mail_conditions.vue?vue&type=script&lang=js&"
import style0 from "./mail_conditions.vue?vue&type=style&index=0&id=5b63289e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b63289e",
  null
  
)

export default component.exports